export const AppColors = [
  "#1E5AAE",
  "#4887E0",
  "#146BB2",
  "#4D4D4D",
  "#666666",
  "#A56186",
  "#B57D9C",
  "#508747",
  "#67AD5B",
];

export const chartColors = [
  "#0F2D57",
  "#164383",
  "#1E5AAE",
  "#4887E0",
  "#7CA9E9",
  "#A8C6F0",
  "#D3E2F8",
  "#1A1A1A",
  "#333333",
  "#4D4D4D",
  "#666666",
  "#a7a59a",
  "#CCCCCC",
  "#E6E6E6",
  "#412534",
  "#61384F",
  "#A56186",
  "#B57D9C",
  "#C79EB5",
  "#DABECD",
  "#ECDFE6",
];

export const tagsColors = [
  "#E0EDF9",
  "#FFFFFF",
  "#FFF687",
  "#DFF1BE",
  "#EDEBE4",
  "#FFE7BC",
  "#FFDDEF",
];

export const tagsColorOldToNewMap = {
  "#F2F6F9": "#E0EDF9",
  "#FFFFFF": "#FFFFFF",
  "#E7F3FE": "#FFF687",
  "#D0E2FA": "#DFF1BE",
  "#A3C3EF": "#EDEBE4",
  "#FDF6EB": "#FFE7BC",
};

export const getTagColor = colorIn => tagsColorOldToNewMap[colorIn] || colorIn;
